var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateMissing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3H23V21H1V3ZM3 5V19H21V5H19V11.5L16 9.25L13 11.5V5H3ZM15 5V7.5L16 6.75L17 7.5V5H15ZM5 11H11V13H5V11ZM5 15H19V17H5V15Z",
    fill: "#FF6600"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 6,
    height: 2,
    fill: "#191A51"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 14,
    height: 2,
    fill: "#191A51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateMissing);
export default __webpack_public_path__ + "static/media/CertificateMissing.cb0950a86b88fec97336c0844b9d082a.svg";
export { ForwardRef as ReactComponent };